import React, { MouseEventHandler } from 'react';
import { CcButton } from '@utp/components-react';
import styled from 'styled-components';

const NavigationStatusElement = styled.div`
  min-height: 32px;
  width: auto;
  display: block;
  float: right;
`;

const NavigationWrapper = styled.div`
  min-height: 32px;
  width: auto;
  display: block;
  float: left;
`;

const NavigationStatusDay = styled.button`
  display: block;
  float: left;
  width: 54px;
  height: 40px;
  border: 1px solid var(--interaction-secondary);
  color: var(--interaction-secondary);
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  margin-right: 32.5px;
  cursor: pointer;
  font-weight: 900;
  font-size: 12px;

  &:hover {
    background: #e2dffd;
  }

  &:focus {
    background: #c6c0fc;
  }

  &:active {
    background: #c6c0fc;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavigationStatusButtons = styled.div`
  display: block;
  float: left;
  .sc-cc-button-h:first-child {
    margin-right: 16px;
  }

  .disabled .button.sc-cc-button {
    pointer-events: none;
    cursor: none;
    color: #adb7c4;
    background: #e6edf2;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavigationButton = styled(CcButton)`
  .button.sc-cc-button {
    width: 40px;
    color: #fff;
    background-color: var(--interaction-secondary);
  }

  .button.sc-cc-button {
    display: flex;
    align-items: center;
    justify-content: center;

    .button__icon.sc-cc-button{
      margin-right: 0px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .button.sc-cc-button: hover{
    background-color: #745EF6;
  }

  .button.sc-cc-button: focus, .button.sc-cc-button: active {
    background-color: #4318CD;
  }
`;

function NavigationStatus(props: any) {
  const {
    onNextButton,
    onPrevButton,
    onTodayButton,
    disabledLeft,
    disabledRight
  } = props;

  const handlePrev: MouseEventHandler<HTMLCcButtonElement> = (e) => {
    (e.target as any).blur();
    (e.target as any).parentElement.blur();
    onPrevButton();
  };

  const handleNext: MouseEventHandler<HTMLCcButtonElement> = (e) => {
    (e.target as any).blur();
    (e.target as any).parentElement.blur();
    onNextButton();
  };

  const handleToday: MouseEventHandler<HTMLButtonElement> = (e) => {
    (e.target as any).blur();
    (e.target as any).parentElement.blur();
    onTodayButton();
  };

  return (
    <NavigationStatusElement>
      <NavigationWrapper>
        <NavigationStatusDay onClick={handleToday}>Hoy</NavigationStatusDay>
        <NavigationStatusButtons>
          <NavigationButton
            size="md"
            onClick={handlePrev}
            className={`${disabledLeft ? 'disabled' : ''}`}
            iconName="chevron-left"
          />
          <NavigationButton
            size="md"
            onClick={handleNext}
            className={`${disabledRight ? 'disabled' : ''}`}
            iconName="chevron-right"
          />
        </NavigationStatusButtons>
      </NavigationWrapper>
    </NavigationStatusElement>
  );
}

NavigationStatus.defaultProps = {};

export default NavigationStatus;
